import { stringIsNullOrEmpty } from "src/common/utilities";
import { ButtonElement } from "../components/button/button-viewModel";
import { CheckboxElement } from "../components/checkbox/checkbox-viewModel";
import { ClientFilterTableElement } from "../components/clientFilterTable/clientFilterTable-viewModel";
import { ServerFilteringTableViewModel } from "../components/clientFilterTable/serverFilteringTable-viewModel";
import { ComboViewModel } from "../components/combo/combo-viewModel";
import { ContentElement } from "../components/content/content-viewModel";
import { DataViewModel } from "../components/date/data-viewModel";
import { DummyPlaceHolderElement } from "../components/dummyPlaceHolder/dummyPlaceHolder-viewModel";
import { DummyTablePlaceHolderComponentElement } from "../components/dummyPlaceHolder/dummyTablePlaceHolderComponent/dummyTablePlaceHolderComponent-viewModel";
import { TdElement } from "../components/dummyPlaceHolder/dummyTablePlaceHolderComponent/td/td-viewModel";
import { GridViewModel } from "../components/grid/grid-viewModel";
import { HrViewModel } from "../components/hr/hr-viewModel";
import { InputElement } from "../components/input/input-viewModel";
import { ListViewModel } from "../components/list/list-viewModel";
import { LoadingViewModel } from "../components/loading/loading-viewModel";
import { MultiLineInputViewModel } from "../components/multiLineInput/multiLineInput-viewModel";
import { ScrollViewModel } from "../components/scroll/scroll-viewModel";
import { SpanElement } from "../components/span/span-viewModel";
import { ChildAcceptableFormBuilderElement, ElementAttachedProperty, ElementProperty, FormBuilderElement, IFormBuilderElementVisitor } from "../structure/element";
import { BindingPropertyValue, IElementPropertyValueVisitor, StaticPropertyValue, UnsetPropertyValue } from "../structure/propertyValue";
import { FilesListViewModel } from "../components/filesList/filesList-viewModel";
import { BindingPrototypeParser } from "src/binder/parser/prototype/bindingPrototype";
import { ImageElement } from "../components/image/image-viewModel";
import { IconElement } from "../components/icon/icon-viewModel";
import { ExpanderViewModel } from "../components/expander/expander-viewModel";
import { BarcodeReaderViewModel } from "../components/barcodeReader/barcodeReader-viewModel";
import { ChartElement } from "../components/chart/chart-viewModel";
import { GuageElement } from "../components/guage/guage-viewModel";
class PropertyValueExtractor implements IElementPropertyValueVisitor{
    visitBindingPropertyValue(arg0: BindingPropertyValue, parameter: object): object {
        return arg0.getValue();
    }
    visitStaticPropertyValue(arg0: StaticPropertyValue, parameter: object): object {
        return arg0.getValue();
    }
    visitUnsetPropertyValue(arg0: UnsetPropertyValue, parameter: object): object {
        return null;
    }
}
class PropertyValueTypeExtractor implements IElementPropertyValueVisitor{
    visitBindingPropertyValue(arg0: BindingPropertyValue, parameter: object): any {
        return 'binding';
    }
    visitStaticPropertyValue(arg0: StaticPropertyValue, parameter: object): any {
        return 'static';
    }
    visitUnsetPropertyValue(arg0: UnsetPropertyValue, parameter: object): any {
        return 'unset';
    }
}
export class HtmlSerializer implements IFormBuilderElementVisitor,IElementPropertyValueVisitor{
    private result:string[];
    private shallSerializeAttachedProperties : boolean = true;
    private hasTooltip : boolean = false;

    public serialize(element:FormBuilderElement):string{
        if(element==null)
            return '';
        let result = this.serializeAsArray(element);
        return result.join('');
    }    

    private startDecoateWithTooltip(element:FormBuilderElement){
        let property = element.findPropertyByName("Tooltip");
        let templateProperty = element.findPropertyByName("TooltipTemplateSelector");
        let value = <string><any>property.elementPropertyValue.Accept(new PropertyValueExtractor(),null);
        let templateValue = <string><any>templateProperty.elementPropertyValue.Accept(new PropertyValueExtractor(),null);
        let valueType = <string><any>property.elementPropertyValue.Accept(new PropertyValueTypeExtractor(),null);
        let templateValueType = <string><any>templateProperty.elementPropertyValue.Accept(new PropertyValueTypeExtractor(),null);
        
        if(stringIsNullOrEmpty(value)==false || stringIsNullOrEmpty(templateValue)==false){
            this.shallSerializeAttachedProperties = false;
            this.hasTooltip = true;
            if(valueType=='static' || (valueType=="binding" && stringIsNullOrEmpty(templateValue))){
                let attachedProperties = element.properties.filter(x=>x instanceof ElementAttachedProperty);
                this.result.push(...['<div data-b-component="tooltip"',...this.convertListOfProperties(attachedProperties),'><div class="tooltip"><h6>',value,'</h6></div>'])
            }else{
                if(value==null){
                    value = "{Binding selfinternaluseonly}"
                }
                let attachedProperties = element.properties.filter(x=>x instanceof ElementAttachedProperty);
                this.result.push(...['<div data-b-component="tooltip"',...this.convertListOfProperties(attachedProperties),'><div class="tooltip">','<div data-b-component="content"data-b-comp-importanthasselectorfunction="true"data-b-comp-itemtemplateselector="{Binding _Builder_TemplateSelector__}"data-b-comp-content="',value,'"data-b-comp-templateselectorfunction="',templateValue,'"></div></div>'])

            }
        }
    }
    private endDecorateWithTooltip(){
        if(this.hasTooltip){
            this.result.push(...['</div>'])
        }
    }
    private serializeAsArray(element:FormBuilderElement):string[]{
        this.result = [];

        this.startDecoateWithTooltip(element);
        element.Accept(this,null);
        this.endDecorateWithTooltip();
        
        return this.result;

    }
    private findSelfElementTabIndex(a:FormBuilderElement):number{
        let finalResult = 100000;
        
        let property = a.findPropertyByName('TabIndex');

        let value = property.value.toString();
        if(value==null)
            finalResult = 100000;
        else{
            let result = parseInt(value.toString());
            if(isNaN(result)){
                finalResult = 100000;
            }else{
                finalResult = result;
            }
        }
        return finalResult;
    }
    private findMinTabIndex(a:FormBuilderElement):number{
        let finalResult = 100000;
        if(a instanceof ChildAcceptableFormBuilderElement){
            finalResult = a.children.map(x=>this.findMinTabIndex(x.self)).filter(x=>x>0).reduce((p,c)=>p<c?p:c,100000);
            let selfResult = this.findSelfElementTabIndex(a);
            finalResult = selfResult>finalResult ? finalResult : selfResult;
        }else{
            finalResult = this.findSelfElementTabIndex(a);
        }
        return finalResult;
    }
    private childrenSortFunction(e1:FormBuilderElement,e2:FormBuilderElement):number{
        let e1Result = this.findMinTabIndex(e1.self);
        let e2Result = this.findMinTabIndex(e2.self);
        return e1Result-e2Result;
    }

    VisitGrid(arg0: GridViewModel, parameter: object): object {
        let elementsData = arg0.children.sortedmap(x=>new HtmlSerializer().serializeAsArray(x),(a,b)=>this.childrenSortFunction(a,b)).flatMap(x=>x);
        this.result.push(...['<div data-b-component="grid"',...this.convertElementProperties(arg0),'>',...elementsData,'</div>'])
        return null;
    }
    VisitExpander(arg0: ExpanderViewModel, parameter: object): object {
        let header = new HtmlSerializer().serializeAsArray(arg0.children.at(0)).flatMap(x=>x);
        let body = new HtmlSerializer().serializeAsArray(arg0.children.at(1)).flatMap(x=>x);
        this.result.push(...['<div data-b-component="expander"',...this.convertElementProperties(arg0),'>','<div class="expander-header">',...header,'</div>','<div class="expander-body">',...body,'</div>','</div>'])
        return null;
    }
    
    VisitDummyPlaceHolder(arg0: DummyPlaceHolderElement, parameter: object): object {
        let elementsData = arg0.children.sortedmap(x=>new HtmlSerializer().serializeAsArray(x),(a,b)=>this.childrenSortFunction(a,b)).flatMap(x=>x);
        
        if(arg0.TemplateType=="Content"){
            let properties = this.convertElementProperties(arg0,["TemplateType"]);
            let className = '';
            if(properties.filter(x=>x.startsWith('data-bcustom-width') || x.startsWith('data-bcustom-height'))){
                className = 'class="popup-size-specifier"';
            }
            this.result.push(...['<div id="3169b9c8-8886-4885-8962-b197e3c391b4"',className,...properties,'>',...elementsData,'</div>']);
        }else if(arg0.TemplateType=='Combo'){
            this.result.push(...['<select><option id="3169b9c8-8886-4885-8962-b197e3c391b4">',...elementsData,'</option></select>']);
        }else if(arg0.TemplateType=="Table"){
            this.result.push(...elementsData);

        }
        return null;
    }
    VisitInput(arg0: InputElement, parameter: object): object {
        this.result.push(...['<div data-b-component="input"',...this.convertElementProperties(arg0),'>','</div>'])
        return null;
    }
    VisitContent(arg0: ContentElement, parameter: object): object {
        console.log(arg0.NeedTemplateSelector);
        console.log(typeof arg0.NeedTemplateSelector);
        if(arg0.NeedTemplateSelector==false){
            this.result.push(...['<div data-b-component="content"',...this.convertElementProperties(arg0),'>','</div>'])
        }else{
            this.result.push(...['<div data-b-component="content"data-b-comp-importanthasselectorfunction="true"data-b-comp-itemtemplateselector="{Binding _Builder_TemplateSelector__}"',...this.convertElementProperties(arg0),'>','</div>'])

        }
        return null;
    }
    VisitComboBox(arg0: ComboViewModel, parameter: object): object {
        this.result.push(...['<div data-b-component="combo"data-b-comp-importanthasselectorfunction="true"data-b-comp-itemtemplateselector="{Binding _Builder_TemplateSelector__}"',...this.convertElementProperties(arg0),'>','</div>'])
        return null;
    }
    VisitSpan(arg0: SpanElement, parameter: object): object {
        let translator = arg0.findPropertyByName("Translator").value;
        this.result.push(...['<span ',...this.convertElementProperties(arg0,['Translator']),'>',...this.convertContentPropertiesWithTranslator(arg0,translator),'</span>'])
        return null;
    }
    VisitDummyTablePlaceHolderComponentElement(arg0: DummyTablePlaceHolderComponentElement, parameter: object): object {
        let elementsData = arg0.children.sortedmap(x=>new HtmlSerializer().serializeAsArray(x),(a,b)=>this.childrenSortFunction(a,b)).flatMap(x=>x);
        this.result.push(...['<table><tbody><tr id="3169b9c8-8886-4885-8962-b197e3c391b4">',...elementsData,'</tr></tbody></table>'])
        return null;
    }
    VisitTdElement(arg0: TdElement, parameter: object): object {
        let elementsData = arg0.children.sortedmap(x=>new HtmlSerializer().serializeAsArray(x),(a,b)=>this.childrenSortFunction(a,b)).flatMap(x=>x);
        this.result.push(...['<td ',...this.convertElementProperties(arg0),'>',...elementsData,'</td>'])
        return null;    
    }
    VisitClientFilterTable(arg0: ClientFilterTableElement, parameter: object): object {
        let columnInfo = '';
        if(stringIsNullOrEmpty(arg0.Columns)==false){
            let columns = arg0.Columns;
            let info = JSON.parse(columns);
            info.forEach(x=>{
                let enumProvider='';
                if(x.type=='enumcolumn' && stringIsNullOrEmpty(x.processId)==false && stringIsNullOrEmpty(x.enumName)==false){
                    enumProvider = `data-b-comp-enumprovider="{Binding {Static ${x.processId},Static ${x.enumName}},Converter:__GetEnumTranslator__}"`;
                }
                if(x.type=='emptycolumn'){
                    columnInfo = columnInfo + `<th data-b-comp-name="${x.title}"class="${x.classList}"style="${x.stylesList}">${x.title}</th>`
                }else if(x.type=='stringcolumn' && stringIsNullOrEmpty(x.stringColumnTableName)==false && stringIsNullOrEmpty(x.stringColumnColumnName)==false){
                    columnInfo = columnInfo + `<th data-b-component="${x.type}"class="${x.classList}"style="${x.stylesList}"data-b-comp-fieldname="${x.fieldName}"data-b-comp-tablename="${x.stringColumnTableName}" data-b-comp-columnname="${x.stringColumnColumnName}"data-b-comp-name="${x.title}"${enumProvider}></th>`
                }else if(x.type=="numbercolumn" && x.customEnums!=null && x.customEnums.length && x.customEnums.length>0){
                    columnInfo = columnInfo + `<th data-b-component="${x.type}"class="${x.classList}"style="${x.stylesList}"data-b-comp-fieldname="${x.fieldName}"data-b-comp-enumfilter="${JSON.stringify(x.customEnums)}"data-b-comp-showEnumFilters="true"data-b-comp-name="${x.title}"${enumProvider}></th>`
                }else{
                    columnInfo = columnInfo + `<th data-b-component="${x.type}"class="${x.classList}"style="${x.stylesList}"data-b-comp-fieldname="${x.fieldName}"data-b-comp-name="${x.title}"${enumProvider}></th>`
                }
            })
        }
        this.result.push(...['<table data-b-component="clientfiltertable"data-b-comp-importanthasselectorfunction="true"data-b-comp-itemtemplateselector="{Binding _Builder_TemplateSelector__}"',...this.convertElementProperties(arg0,['Columns']),'><thead>',columnInfo,'</thead><tbody>','</tbody></table>'])
        return null;
    }
    VisitServerFilterTable(arg0: ServerFilteringTableViewModel, parameter: object): object {
        let columnInfo = '';
        if(stringIsNullOrEmpty(arg0.Columns)==false){
            let columns = arg0.Columns;
            let info = JSON.parse(columns);
            info.forEach(x=>{
                let enumProvider='';
                if(x.type=='enumcolumn' && stringIsNullOrEmpty(x.processId)==false && stringIsNullOrEmpty(x.enumName)==false){
                    enumProvider = `data-b-comp-enumprovider="{Binding {Static ${x.processId},Static ${x.enumName}},Converter:__GetEnumTranslator__}"`;
                }
                if(x.type=='emptycolumn'){
                    columnInfo = columnInfo + `<th class="${x.classList}"style="${x.stylesList}"${enumProvider}>${x.title}</th>`
                }else if(x.type=='stringcolumn' && stringIsNullOrEmpty(x.stringColumnTableName)==false && stringIsNullOrEmpty(x.stringColumnColumnName)==false){
                    columnInfo = columnInfo + `<th data-b-component="${x.type}"class="${x.classList}"style="${x.stylesList}"data-b-comp-fieldname="${x.fieldName}"data-b-comp-tablename="${x.stringColumnTableName}" data-b-comp-columnname="${x.stringColumnColumnName}"data-b-comp-name="${x.title}"${enumProvider}></th>`
                }else if(x.type=="numbercolumn" && x.customEnums!=null && x.customEnums.length && x.customEnums.length>0){
                    columnInfo = columnInfo + `<th data-b-component="${x.type}"class="${x.classList}"style="${x.stylesList}"data-b-comp-fieldname="${x.fieldName}"data-b-comp-enumfilter='${JSON.stringify(x.customEnums)}'data-b-comp-showEnumFilters="true"data-b-comp-name="${x.title}"${enumProvider}></th>`
                }else{
                    columnInfo = columnInfo + `<th data-b-component="${x.type}"class="${x.classList}"style="${x.stylesList}"data-b-comp-fieldname="${x.fieldName}"data-b-comp-name="${x.title}"${enumProvider}></th>`
                }
            })
        }
        this.result.push(...['<table data-b-component="serverfiltertable"data-b-comp-importanthasselectorfunction="true"data-b-comp-itemtemplateselector="{Binding _Builder_TemplateSelector__}"',...this.convertElementProperties(arg0,['Columns']),'><thead>',columnInfo,'</thead><tbody>','</tbody></table>'])
        return null;
    }
    
    VisitButton(arg0: ButtonElement, parameter: object): object {
        let elementsData = arg0.children.sortedmap(x=>new HtmlSerializer().serializeAsArray(x),(a,b)=>this.childrenSortFunction(a,b)).flatMap(x=>x);
        this.result.push(...['<div data-b-component="button"',...this.convertElementProperties(arg0),'>',...elementsData,'</div>'])
        return null;
    }
    VisitCheckBox(arg0: CheckboxElement, parameter: object): object {
        this.result.push(...['<div data-b-component="checkbox"',...this.convertElementProperties(arg0),'>','</div>'])
        return null;
    }
    VisitDate(arg0: DataViewModel, parameter: object): object {
        this.result.push(...['<div data-b-component="date"',...this.convertElementProperties(arg0),'>','</div>'])
        return null;
    }
    VisitChart(arg0: ChartElement, parameter: object): object {
        this.result.push(...['<div data-b-component="chart"',...this.convertElementProperties(arg0),'>','</div>'])
        return null;
    }
    VisitGuage(arg0: GuageElement, parameter: object): object {
        this.result.push(...['<div data-b-component="guage"',...this.convertElementProperties(arg0),'>','</div>'])
        return null;
    }
    
    VisitHr(arg0: HrViewModel, parameter: object): object {
        let elementsData = arg0.children.sortedmap(x=>new HtmlSerializer().serializeAsArray(x),(a,b)=>this.childrenSortFunction(a,b)).flatMap(x=>x);
        this.result.push(...['<div data-b-component="hr"',...this.convertElementProperties(arg0),'><div>',...elementsData,'</div></div>'])
        return null;
    }
    VisitList(arg0: ListViewModel, parameter: object): object {
        this.result.push(...['<div data-b-component="list"data-b-comp-importanthasselectorfunction="true"data-b-comp-itemtemplateselector="{Binding _Builder_TemplateSelector__}"',...this.convertElementProperties(arg0),'></div>'])
        return null;
    }
    VisitLoading(arg0: LoadingViewModel, parameter: object): object {
        let elementsData = arg0.children.sortedmap(x=>new HtmlSerializer().serializeAsArray(x),(a,b)=>this.childrenSortFunction(a,b)).flatMap(x=>x);
        this.result.push(...['<div data-b-component="loading"',...this.convertElementProperties(arg0),'>',...elementsData,'</div>'])
        return null;
    }
    VisitMultiLineInput(arg0: MultiLineInputViewModel, parameter: object): object {
        this.result.push(...['<div data-b-component="multilineinput"',...this.convertElementProperties(arg0),'>','</div>'])
        return null;
    }
    VisitScroll(arg0: ScrollViewModel, parameter: object): object {
        let elementsData = arg0.children.sortedmap(x=>new HtmlSerializer().serializeAsArray(x),(a,b)=>this.childrenSortFunction(a,b)).flatMap(x=>x);
        this.result.push(...['<div data-b-component="scroll"',...this.convertElementProperties(arg0),'>',...elementsData,'</div>'])
        return null;
    }
    VisitFilesList(arg0: FilesListViewModel, parameter: object): object {
        this.result.push(...['<div data-b-component="fileslist"',...this.convertElementProperties(arg0),'>','</div>'])
        return null;
    }
    VisitImage(arg0: ImageElement, parameter: object): object {
        this.result.push(...['<div data-b-class-divimageelement="{Static true}"',...this.convertElementProperties(arg0),'></div>'])
        return null;
    }
    VisitIcon(arg0: IconElement, parameter: object): object {
        this.result.push(...['<i ',...this.convertElementProperties(arg0),'></i>'])
        return null;
    }
    VisitBarcodeReader(arg0: BarcodeReaderViewModel, parameter: object): object {
        this.result.push(...['<div data-b-component="barcodereader"',...this.convertElementProperties(arg0),'>','</div>'])
        return null;
    }
    
    visitBindingPropertyValue(arg0: BindingPropertyValue, parameter: object): object {
        let elementPropery = <ElementProperty>parameter
        return [elementPropery.property.attributeName,'="',arg0.getValue(),'"'];
    }
    visitStaticPropertyValue(arg0: StaticPropertyValue, parameter: object): object {
        let elementPropery = <ElementProperty>parameter
        return [elementPropery.property.attributeName,'="',arg0.getValue(),'"'];
    }
    visitUnsetPropertyValue(arg0: UnsetPropertyValue, parameter: object): object {
        return null;
    }
    
    private convertListOfProperties(properties:ElementProperty[]):string[]{
        let result = [];
        let visitor = this;

        properties.forEach(x=>{
            if(x.property.canBeContent==false){
                let value = x.elementPropertyValue.Accept(visitor,x);
                if(value!=null){
                    result.push(...[value]);                    
                }
            }
        });
        return result.flatMap(x=>x);
    }
    private convertElementProperties(element:FormBuilderElement,omittingPropertyNames:string[]=[]):string[]{
        let result = [];
        let visitor = this;
        omittingPropertyNames.push('TabIndex')
        omittingPropertyNames.push('Tooltip')
        omittingPropertyNames.push('TooltipTemplateSelector')
        omittingPropertyNames.push('NeedTemplateSelector')

        let properties = element.properties.filter(x=>
            x.property.canBeContent==false && 
            omittingPropertyNames.indexOf(x.property.name)==-1 &&
            (this.shallSerializeAttachedProperties==true || (x instanceof ElementAttachedProperty)==false));
        properties.forEach(x=>{
            if(x.property.canBeContent==false && omittingPropertyNames.indexOf(x.property.name)==-1){
                let value = x.elementPropertyValue.Accept(visitor,x);
                if(value!=null){
                    result.push(...[value]);                    
                }
            }
        });
        return result.flatMap(x=>x);
    }
    private convertContentProperties(element:FormBuilderElement):string[]{
        let contentProperties = element.properties.filter(x=>x.property.canBeContent==true);
        if(contentProperties.length==1){
            let visitor = new propertyValueExtractor();
            let value = <string[]>contentProperties[0].elementPropertyValue.Accept(visitor,null);
            return [...value];
        }
        return [];
    }
    private isjson(s):boolean{
        try{
            JSON.parse(s);
            return true;
        }catch{

        }
        return false;
    }
    private convertContentPropertiesWithTranslator(element:FormBuilderElement,translatorInfo:string):string[]{
        let contentProperties = element.properties.filter(x=>x.property.canBeContent==true);
        if(contentProperties.length==1){
            let visitor = null;
            
            if(stringIsNullOrEmpty(translatorInfo) || this.isjson(translatorInfo)==false){
                visitor = new propertyValueExtractor();
            }else{
                visitor = new propertyValueExtractorWithTranslatorInfo(translatorInfo);
            }
            let value = <string[]>contentProperties[0].elementPropertyValue.Accept(visitor,null);
            return [...value];

        }
        return [];
    }

    
} 

class propertyValueExtractor implements IElementPropertyValueVisitor{
    
    visitBindingPropertyValue(arg0: BindingPropertyValue, parameter: object): object {
        return [arg0.getValue()];
    }
    visitStaticPropertyValue(arg0: StaticPropertyValue, parameter: object): object {
        return [arg0.getValue()];
    }
    visitUnsetPropertyValue(arg0: UnsetPropertyValue, parameter: object): object {
        return [];
    }
}
class propertyValueExtractorWithTranslatorInfo implements IElementPropertyValueVisitor{
    
    private processId :string;
    private enumName : string;
    constructor(translatorInfo:string) {
        let typed = JSON.parse(translatorInfo);
        this.processId = typed.processId
        this.enumName = typed.enumName;
    }
    visitBindingPropertyValue(arg0: BindingPropertyValue, parameter: object): object {
        let value = arg0.getValue();
        let parsed = BindingPrototypeParser.ParseBinding(value);
        let property = parsed.getSources()[0];
        let result = `{Binding {${property},Static ${this.processId},Static ${this.enumName}},Converter:__TranslateEnum__}`;
        return [result];
    }
    visitStaticPropertyValue(arg0: StaticPropertyValue, parameter: object): object {
        return [arg0.getValue()];
    }
    visitUnsetPropertyValue(arg0: UnsetPropertyValue, parameter: object): object {
        return [];
    }
}